import React from 'react';
import styles from '../../styles/game/LivesDisplay.module.css';

/**
 * LivesDisplay - Displays remaining lives as filled/empty circles
 * 
 * @param {number} lives - Current number of lives remaining
 * @param {number} maxLives - Maximum number of lives (default: 5)
 * @param {string} className - Optional additional class name
 */
const LivesDisplay = ({ lives, maxLives = 5, className = '' }) => {
  return (
    <div className={`${styles.livesContainer} ${className}`}>
      {[...Array(maxLives)].map((_, index) => (
        <div
          key={index}
          className={`${styles.lifeCircle} ${index < lives ? styles.filled : styles.empty}`}
        />
      ))}
    </div>
  );
};

export default LivesDisplay;


